@if (isAsideMenuVisible) {
  <app-overlay (overlayClick)="onOverlayClick()"></app-overlay>
}
<div
  [class.app-aside--collapsed]="isAsideCollapsed"
  [class.app-aside--with-appcues-banner]="isAppcuesBannerVisible"
  class="app-aside"
></div>
